import {
	endpointsMap,
	IShareProductOptions,
	IShareProductResponse,
	ICalculateCustomProductPriceOptions,
	ICalculateCustomProductPriceResponse
} from './ICustomShopperProduct';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperProduct
 */
class CustomShopperProduct extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Share the product from a customer to another
	 * @param {IShareProductOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IShareProductResponse} - Status of the request
	 */
	public async shareProduct(fetchOptions: IShareProductOptions, throwOnError?: boolean): Promise<IShareProductResponse> {
		const response: IShareProductResponse = await this.callCustomEndpoint<IShareProductResponse>(
			fetchOptions,
			endpointsMap.SHARE
		);

		if (throwOnError && response.message !== 'PRODUCT_EMAIL_SENT') {
			throw new Error(response.title || 'No email sent');
		}

		return response;
	}

	/**
	 * Calculate the product price from a personalization
	 * @param {ICalculateCustomProductPriceOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {ICalculateCustomProductPriceResponse} - Status of the request
	 */
	public async calculateCustomProductPrice(
		fetchOptions: ICalculateCustomProductPriceOptions,
		throwOnError?: boolean
	): Promise<ICalculateCustomProductPriceResponse> {
		const response: ICalculateCustomProductPriceResponse = await this.callCustomEndpoint<ICalculateCustomProductPriceResponse>(
			fetchOptions,
			endpointsMap.CALCULATE_CUSTOM_PRODUCT_PRICE
		);

		if (throwOnError && !response.customPrice) {
			throw new Error(response.title || 'Calculate price error');
		}

		return response;
	}
}

export default CustomShopperProduct;
